var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6882 0.311812C10.2724 -0.103937 9.59847 -0.103937 9.18272 0.311812L5.49997 3.99461L1.81727 0.311864C1.40147 -0.103886 0.727458 -0.103886 0.311812 0.311864C-0.103937 0.727614 -0.103937 1.40158 0.311812 1.81733L3.99451 5.50008L0.311812 9.18278C-0.103937 9.59853 -0.103937 10.2725 0.311812 10.6882C0.519635 10.8962 0.791985 11 1.06444 11C1.33689 11 1.60935 10.8961 1.81727 10.6882L5.49997 7.00554L9.18272 10.6882C9.39055 10.8962 9.663 11 9.93545 11C10.2079 11 10.4804 10.8962 10.6882 10.6882C11.1039 10.2725 11.1039 9.59853 10.6882 9.18278L7.00543 5.50008L10.6882 1.81733C11.1039 1.40158 11.1039 0.727562 10.6882 0.311812Z",
    fill: "#71717B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIcon);
export default __webpack_public_path__ + "static/media/cancel-icon.d3f5861b93c4441f11d1f326dc425db0.svg";
export { ForwardRef as ReactComponent };